import { Component, OnInit} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AdminService } from "../../services/admin.service";
import { apiUrl } from "../../global/global";
import { HttpParams } from "@angular/common/http";
import * as CONSTANT from "../../services/constants"
import swal from "sweetalert2";
import { ImageUrls } from "src/app/services/s3buket";

@Component({
  selector: "app-candidates",
  templateUrl: "./candidates.component.html",
  styleUrls: ["./candidates.component.css"]
})
export class CandidatesComponent implements OnInit {
  usersData:any = [];
  currentPage:number | undefined;
  pagination = {limit: CONSTANT.LIMIT, maxSize: CONSTANT.MAX_SIZE, skip: 0, totalItems: ""}
  totalCount: any;
  sortType: any;
  sortBy : string = ""
  orderBy: string = "2";
  search="";
  archiveUserSearch = "";
  closeSearch:boolean = false;
  globalUrl = ImageUrls.BaseUrl + ImageUrls.directories.users;
  currentDate= new Date()
  constructor(public route: ActivatedRoute, private router: Router,private api: AdminService) { }

  ngOnInit(): void {
    this.getFavCandidates();
  }

  getFavCandidates(){
    let params = new HttpParams(); 
    params = params.append("skip", this.pagination.skip.toString());
    params = params.append("limit", this.pagination.limit.toString());
    params = params.append("favourite", 1);
    if (this.search != null && this.search != "") {
      // let search = encodeURIComponent(this.search);
      params = params.append("search", this.search);
    }
    if (this.sortBy) { params.append("sortBy",this.sortBy.trim() ? this.sortBy.trim() : "");
      params = params.append("orderBy", this.orderBy == "ASC" ? "ASC" : "DESC");
    }
    this.api.getData(apiUrl._getFavCandidates,params)
    .subscribe(async (res) => {
      this.pagination.totalItems = res.data.count; 
      this.totalCount = res.data.count; 
      this.usersData = res.data.data;
      this.usersData.map((userData)=>{
        let pastWork : any = []; 
        
        userData?.user?.user_work_experiences.map((workType)=>{ 
          pastWork.push(workType) 
        })
        userData["pastWork"] = pastWork; 
      })
    })
  } 
  // ============= For Active Users
  pageChanged(event: any): void {
    if (event == this.currentPage) return;
    this.currentPage = event;
    this.pagination.skip = (event - 1) * this.pagination.limit;
    window.scroll(0, 0);
    this.getFavCandidates();
  }
  searchFun() {  
    this.currentPage = 1;
    this.pagination.skip = 0; 
    this.closeSearch = true; 
    
    if( this.usersData.length > 0){
      this.getFavCandidates();}
    }
  clearSearch() {
    this.search= "";
    this.closeSearch = false;
    this.pagination.skip = 0; 
    localStorage.removeItem("type-redirect");
    
    // if( this.usersData.length > 0){
      this.getFavCandidates();
    // }
  }
  updateStatus(data){
    console.log(data);
    let userData=data
    
    let text = "<p>Are you sure you want to remove this user ?</p>";
    swal.fire({
      html: text,
      showCloseButton: false,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonColor: "#EF7E2B",
      cancelButtonColor: "#ffffff",
      confirmButtonText:"Yes",
      cancelButtonText: "No",
      reverseButtons: true,
      width: 500
    }).then((result) => {
      if (result.value) { 
        const data = {
          "id": userData.id, 
          // "favourite": 0, 
        }
        this.api.deleteData(apiUrl._getFavCandidates, data).subscribe(res => {
          this.getFavCandidates();
        })
      }
    });
  }
 // redirect to
 redirectTo(data){
  this.router.navigate([`/jobs/applicant/${data.jobPostId}/appdetail/`], {queryParams : { userId: `${data.userId}`, applicantId: `${data.id}` }});
}
// date ago 
totalExperience(data) {
  let totalYears = 0
  let totalMonths = 0
  data.pastWork.map((work) => {
    totalYears += this.dateDiffCalculator(work.fromDate != null ? work.fromDate : "0", work.toDate != null ? work.toDate : this.currentDate)["years"];
    totalMonths += this.dateDiffCalculator(work.fromDate != null ? work.fromDate : "0",  work.toDate != null ? work.toDate : this.currentDate)["months"];
  })

  while(totalMonths > 11) {
    totalYears += 1;
    totalMonths -= 12;
  }

  return totalMonths == 0 ? totalYears + " years" : totalYears + " years "
}

dateDiffCalculator(fromDate,toDate) : any {
  if(fromDate != null && toDate != null){
    var startDate:any = new Date(fromDate);
    var endDate:any = new Date(toDate);
    var diffDate:any = new Date(endDate - startDate);
    return {"years" : (diffDate.toISOString().slice(0, 4) - 1970)}
  }
}
}
